<template>
    <div class="offer-wrapper order-wrapper" id="onfocusheight">
        <b-tabs content-class="mt-3" fill>
            <b-tab :title="$t('placeholder.headerProduse')">
                <div class="offerprod-header">
                    <div class="search-form">
                        <input
                                class="search-input"
                                type="search"
                                :placeholder="$t('placeholder.cautaProdus')"
                                name="q"
                                id="product-search"
                                v-model="search_products">
                        <span class="focus-input"></span>
                        <span class="symbol-input" >
                                <i class="fas fa-search"></i>
                            </span>
                    </div>
                </div>
                <div class="row items-main-row" v-if="this.products">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                        <div class="template-items-header">
                            <ul>
                                <li v-bind:class="[selected_search_header === 'name' ? 'item-header-active' : '', 'item-header-name']" @click="selected_search_header ='name'">
                                    <p> Nume </p>
                                </li>
                                <li v-bind:class="[selected_search_header === 'manufacturer' ? 'item-header-active' : '', 'item-header-manufacturer']" @click="selected_search_header = 'manufacturer'">
                                    <p> Producator </p>
                                </li>
                                <li v-bind:class="[selected_search_header === 'internal' ? 'item-header-active' : '', 'item-header-internal']" @click="selected_search_header = 'internal'">
                                    <p> Cod Intern </p>
                                </li>
                                <li v-bind:class="[selected_search_header === 'external' ? 'item-header-active' : '', 'item-header-external']" @click="selected_search_header = 'external'">
                                    <p> Cod Extern </p>
                                </li>
                                <li class="item-header-price">
                                    <p> Pret </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                        <div class="item-wrapper" role="tablist">
                            <div class="item-slot" v-for="(product, index) in products" :key="product.id">
                                <div class="item-row-upper">
                                    <div class="item-name-slot">
                                        <b-btn  v-b-toggle="'accordion' + index" variant="primary" role="tabpanel">
                                            <i class="fas fa-ellipsis-h"></i>
                                            <h4> {{product.name}}</h4>
                                        </b-btn>
                                    </div>
                                    <div class="item-manufacturer">
                                        <p> {{product.manufacturer || '-'}} </p>
                                    </div>
                                    <div class="item-internal-code">
                                        <p> {{product.cod_intern || '-'}}  </p>
                                    </div>
                                    <div class="item-external-code">
                                        <p> {{product.cod_extern || '-'}} </p>
                                    </div>
                                    <div class="item-price">
                                        <p> {{product.final_price | formatPrice}} </p>
                                    </div>
                                </div>
                                <b-collapse :id="'accordion' + index" accordion="my-accordion" role="tabpanel">
                                    <div class="item-row-lower">
                                        <div class="warehouse-list" v-if="warehouses">
                                            <ul>
                                                <li v-for="warehouse in warehouses.slice(0, Math.ceil(warehouses.length/2))" :key="warehouse.id">
                                                    <p> {{warehouse.key}} </p>
                                                    <div class="item-stock-status">
                                                        <p class="item-stock1"> {{getQty(product.stock, warehouse.id)}} </p>
                                                        <p  class="item-stock2"> {{getQtyReserved(product.stock, warehouse.id)}} </p>
                                                    </div>
                                                    <input v-if="userWarehouses.find(userWrh => userWrh.id === warehouse.id)" type="number" v-on:keyup.enter="addItem(index, 'products')" :data-product="product.id" :data-warehouse-id="warehouse.id" :data-warehouse-name="warehouse.name" :data-warehouse-key="warehouse.key">
                                                </li>
                                            </ul>
                                            <ul>
                                                <li v-for="warehouse in warehouses.slice(Math.ceil(warehouses.length/2), warehouses.length)" :key="warehouse.id">
                                                    <p> {{warehouse.key}} </p>
                                                    <div class="item-stock-status">
                                                        <p class="item-stock1"> {{getQty(product.stock, warehouse.id)}} </p>
                                                        <p  class="item-stock2"> {{getQtyReserved(product.stock, warehouse.id)}} </p>
                                                    </div>
                                                    <input v-if="userWarehouses.find(userWrh => userWrh.id === warehouse.id)" type="number" v-on:keyup.enter="addItem(index, 'products')" :data-product="product.id" :data-warehouse-id="warehouse.id" :data-warehouse-name="warehouse.name" :data-warehouse-key="warehouse.key">
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="order-add-product">
                                            <button type="button" tabindex="-1" @click="addItem(index, 'products')">
                                                <i class="fas fa-plus"></i>
                                                <span> {{$t('txt.adaugaProdus')}} </span>
                                            </button>
                                        </div>
                                    </div>
                                </b-collapse>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="offer-products-pagination" v-if="this.products">
                    <div class="pagination-wrapper">
                        <ul class="pagination-box">
                            <li class="pagination-point" v-if="this.meta_products.current_page !== 1">
                                <a href="javascript:void(0)" @click="applyQueryProducts({ page: 1 })" class="Previous">
                                    <i class="fas fa-angle-double-left pag-left"></i>
                                </a>
                            </li>
                            <li class="pagination-point" v-if="this.meta_products.current_page !== 1">
                                <a href="javascript:void(0)" @click="applyQueryProducts({ page: meta_products.current_page-1 })"
                                   class="Previous">
                                    <i class="fas fa-angle-left pag-left"></i>
                                </a>
                            </li>
                            <li class="pp-dot" v-for="page in products_pagination"
                                :class="{'pp-dot-active': meta_products.current_page === page }" :key="page">
                                <a href="javascript:void(0)" @click="applyQueryProducts({ page: page })">{{page}}</a>
                            </li>
                            <li class="pagination-point" v-if="this.meta_products.current_page !== this.meta_products.last_page">
                                <a href="javascript:void(0)" @click="applyQueryProducts({ page: meta_products.current_page+1 })">
                                    <i class="fas fa-angle-right pag-right"></i>
                                </a>
                            </li>
                            <li class="pagination-point" v-if="this.meta_products.current_page !== this.meta_products.last_page">
                                <a href="javascript:void(0)" @click="applyQueryProducts({ page: meta_products.last_page })">
                                    <i class="fas fa-angle-double-right pag-right"></i>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </b-tab>
            <!--                <b-tab :title="$t('placeholder.headerServicii')">-->
            <!--                    <div class="offerprod-header">-->
            <!--                        <div class="search-form">-->
            <!--                            <input-->
            <!--                                    class="search-input"-->
            <!--                                    type="search"-->
            <!--                                    :placeholder="$t('placeholder.cautaServiciu')"-->
            <!--                                    name="q"-->
            <!--                                    id="service-search"-->
            <!--                                    v-model="search_services"-->
            <!--                                    @change="applyQueryServices({ q: search_services })"-->
            <!--                            >-->
            <!--                            <span class="focus-input"></span>-->
            <!--                            <span class="symbol-input">-->
            <!--                                <i class="fas fa-search"></i>-->
            <!--                            </span>-->
            <!--                        </div>-->
            <!--                    </div>-->
            <!--                    <div class="row" v-if="this.services">-->
            <!--                        <div class="col-xl-12 col-lg-12 col-md-12 col-12">-->
            <!--                            <div class="offer-product-slot">-->
            <!--                                <div class="offer-product-row" v-for="(service, index) in services" :key="service.id">-->
            <!--                                    <div class="offer-prdrow-first">-->
            <!--                                        <h4> {{service.name}} </h4>-->
            <!--                                    </div>-->
            <!--                                    <div class="offer-prdrow-second">-->
            <!--                                        <div class="offer-product-quant">-->
            <!--                                            <p class="subtract" @click="decreaseQuantity(index, 'services')"> - </p>-->
            <!--                                            <input type="number"-->
            <!--                                                   class="qty_input"-->
            <!--                                                   min="1"-->
            <!--                                                   max="99"-->
            <!--                                                   v-model="services[index].qty"-->
            <!--                                                   v-on:keyup.enter="addItem(index, 'services')">-->
            <!--                                            <p class="add" @click="increaseQuantity(index, 'services')"> + </p>-->
            <!--                                        </div>-->
            <!--                                        <div class="offer-product-price">-->
            <!--                                            <p> {{service.final_price | formatPrice}} </p>-->
            <!--                                            &lt;!&ndash;<span> RON </span>&ndash;&gt;-->
            <!--                                        </div>-->
            <!--                                        <div class="offer-add-product">-->
            <!--                                            <button type="button" @click="addItem(index, 'services')" tabindex="-1">-->
            <!--                                                 <i class="fas fa-plus"></i>-->
            <!--                                                <span> {{$t('txt.adaugaServiciu')}} </span>-->
            <!--                                            </button>-->
            <!--                                        </div>-->
            <!--                                    </div>-->
            <!--                                </div>-->
            <!--                            </div>-->
            <!--                        </div>-->
            <!--                    </div>-->
            <!--                    <div class="offer-products-pagination" v-if="this.services">-->
            <!--                        <div class="pagination-wrapper">-->
            <!--                            <ul class="pagination-box">-->
            <!--                                <li class="pagination-point" v-if="this.meta_services.current_page !== 1">-->
            <!--                                    <a href="javascript:void(0)" @click="applyQueryServices({ page: 1 })" class="Previous">-->
            <!--                                        <i class="fas fa-angle-double-left pag-left"></i>-->
            <!--                                    </a>-->
            <!--                                </li>-->
            <!--                                <li class="pagination-point" v-if="this.meta_services.current_page !== 1">-->
            <!--                                    <a href="javascript:void(0)" @click="applyQueryServices({ page: meta_services.current_page-1 })"-->
            <!--                                       class="Previous">-->
            <!--                                        <i class="fas fa-angle-left pag-left"></i>-->
            <!--                                    </a>-->
            <!--                                </li>-->
            <!--                                <li class="pp-dot" v-for="page in services_pagination"-->
            <!--                                    :class="{'pp-dot-active': meta_services.current_page === page }" :key="page">-->
            <!--                                    <a href="javascript:void(0)" @click="applyQueryServices({ page: page })">{{page}}</a>-->
            <!--                                </li>-->
            <!--                                <li class="pagination-point" v-if="this.meta_services.current_page !== this.meta_services.last_page">-->
            <!--                                    <a href="javascript:void(0)" @click="applyQueryServices({ page: meta_services.current_page+1 })">-->
            <!--                                        <i class="fas fa-angle-right pag-right"></i>-->
            <!--                                    </a>-->
            <!--                                </li>-->
            <!--                                <li class="pagination-point" v-if="this.meta_services.current_page !== this.meta_services.last_page">-->
            <!--                                    <a href="javascript:void(0)" @click="applyQueryServices({ page: meta_services.last_page })">-->
            <!--                                        <i class="fas fa-angle-double-right pag-right"></i>-->
            <!--                                    </a>-->
            <!--                                </li>-->
            <!--                            </ul>-->
            <!--                        </div>-->
            <!--                    </div>-->
            <!--                </b-tab>-->
            <!--                <b-tab :title="$t('placeholder.headerServiciiPostVanzare')">-->
            <!--                    <div class="offerprod-header">-->
            <!--                        <div class="search-form">-->
            <!--                            <input-->
            <!--                                    class="search-input"-->
            <!--                                    type="search"-->
            <!--                                    :placeholder="$t('placeholder.cautaServiciu')"-->
            <!--                                    name="q"-->
            <!--                                    id="post-service-search"-->
            <!--                                    v-model="search_post_services"-->
            <!--                                    @change="applyQueryPostServices({ q: search_post_services })"-->
            <!--                            >-->
            <!--                            <span class="focus-input"></span>-->
            <!--                            <span class="symbol-input">-->
            <!--                                    <i class="fas fa-search"></i>-->
            <!--                                </span>-->
            <!--                        </div>-->
            <!--                    </div>-->
            <!--                    <div class="row" v-if="this.post_services">-->
            <!--                        <div class="col-xl-12 col-lg-12 col-md-12 col-12">-->
            <!--                            <div class="offer-product-slot">-->
            <!--                                <div class="offer-product-row" v-for="(post_service, index) in post_services" :key="post_service.id">-->
            <!--                                    <div class="offer-prdrow-first">-->
            <!--                                        <div class="offer-product-image">-->
            <!--                                        </div>-->
            <!--                                        <router-link :to="{ name: 'viewpostsaleservice', params: { id: post_service.id }}">-->
            <!--                                            <h4> {{post_service.name}} </h4>-->
            <!--                                        </router-link>-->
            <!--                                    </div>-->
            <!--                                    <div class="offer-prdrow-second">-->
            <!--                                        <div class="offer-product-quant">-->
            <!--                                            <p class="subtract" @click="decreaseQuantity(index, 'post_services')"> - </p>-->
            <!--                                            <input type="number"-->
            <!--                                                   min="1"-->
            <!--                                                   max="99"-->
            <!--                                                   v-model="post_services[index].qty"-->
            <!--                                                   v-on:keyup.enter="addItem(index, 'post_services')">-->
            <!--                                            <p class="add" @click="increaseQuantity(index, 'post_services')"> + </p>-->
            <!--                                        </div>-->
            <!--                                        <div class="offer-product-price">-->
            <!--                                            <p> {{post_service.price | formatPrice}} </p>-->
            <!--                                            &lt;!&ndash;<span> RON </span>&ndash;&gt;-->
            <!--                                        </div>-->
            <!--                                        <div class="offer-add-product">-->
            <!--                                            <button type="button" @click="addItem(index, 'post_services')" tabindex="-1">-->
            <!--                                                 <i class="fas fa-plus"></i>-->
            <!--                                                <span> {{$t('txt.adaugaServiciu')}} </span>-->
            <!--                                            </button>-->
            <!--                                        </div>-->
            <!--                                    </div>-->
            <!--                                </div>-->
            <!--                            </div>-->
            <!--                        </div>-->
            <!--                    </div>-->
            <!--                    <div class="offer-products-pagination" v-if="this.post_services">-->
            <!--                        <div class="pagination-wrapper">-->
            <!--                            <ul class="pagination-box">-->
            <!--                                <li class="pagination-point" v-if="this.meta_post_services.current_page !== 1">-->
            <!--                                    <a href="javascript:void(0)" @click="applyQueryPostServices({ page: 1 })" class="Previous">-->
            <!--                                        <i class="fas fa-angle-double-left pag-left"></i>-->
            <!--                                    </a>-->
            <!--                                </li>-->
            <!--                                <li class="pagination-point" v-if="this.meta_post_services.current_page !== 1">-->
            <!--                                    <a href="javascript:void(0)" @click="applyQueryPostServices({ page: meta_post_services.current_page-1 })"-->
            <!--                                       class="Previous">-->
            <!--                                        <i class="fas fa-angle-left pag-left"></i>-->
            <!--                                    </a>-->
            <!--                                </li>-->
            <!--                                <li class="pp-dot" v-for="page in post_service_pagination"-->
            <!--                                    :class="{'pp-dot-active': meta_post_services.current_page === page }" :key="page">-->
            <!--                                    <a href="javascript:void(0)" @click="applyQueryPostServices({ page: page })">{{page}}</a>-->
            <!--                                </li>-->
            <!--                                <li class="pagination-point" v-if="this.meta_post_services.current_page !== this.meta_post_services.last_page">-->
            <!--                                    <a href="javascript:void(0)" @click="applyQueryPostServices({ page: meta_post_services.current_page+1 })">-->
            <!--                                        <i class="fas fa-angle-right pag-right"></i>-->
            <!--                                    </a>-->
            <!--                                </li>-->
            <!--                                <li class="pagination-point" v-if="this.meta_post_services.current_page !== this.meta_post_services.last_page">-->
            <!--                                    <a href="javascript:void(0)" @click="applyQueryPostServices({ page: meta_post_services.last_page })">-->
            <!--                                        <i class="fas fa-angle-double-right pag-right"></i>-->
            <!--                                    </a>-->
            <!--                                </li>-->
            <!--                            </ul>-->
            <!--                        </div>-->
            <!--                    </div>-->
            <!--                </b-tab>-->
        </b-tabs>
    </div>
</template>

<script>
import ProductsService from '../api-services/products.service'
export default {
  name: 'produsele-window',
  data () {
    return {
      products: [],
      warehouses: [],
      added: [],
      search_products: null,
      userWarehouses: null,
      selected_search_header: null,
      meta_products: {},
      meta_services: {},
      meta_post_services: {},
      globalPriceRange: {
        key: 4,
        name: 'price_retail'
      },
      order_rows: this.$store.getters.getUserProductsOrder || {
        products: []
      }
    }
  },
  watch: {
    search_products: async function (val) {
      let response = await ProductsService.getSearchData({ q: val, per_page: 40, q_in: this.selected_search_header })
      this.products = response.data.data
      this.meta_products = response.data.meta
    }
  },
  methods: {
    getWarehouses () {
      ProductsService.getWarehouses()
        .then((response) => {
          this.warehouses = response.data.data.data
        })
        .catch((error) => {
          console.log(error)
          this.getWarehouses()
        })
    },
    getProducts () {
      ProductsService.getAll(({ per_page: 40 }))
        .then((response) => {
          if (response.data.data.length > 0) {
            this.products = response.data.data
          } else {
            this.products = null
          }
          this.meta_products = response.data.meta
          this.$store.dispatch('hideLoading')
        })
        .catch((error) => {
          console.log(error)
          this.$store.dispatch('hideLoading')
        })
    },
    addItem (index, collection) {
      let row = this.order_rows[collection].find(row => row.id === this[collection][index].id)
      let collectionName = ''
      switch (collection) {
        case 'products':
          collectionName = 'Produsul'
          break

        case 'services':
          collectionName = 'Serviciul'
          break

        case 'post_services':
          collectionName = 'Serviciul Post Vanzare'
          break
      }
      if (row) {
        // this.checkQuantity(index, collection)
        if (collection === 'products') {
          let inputs = document.querySelectorAll("input[data-product='" + this.products[index].id + "']")
          let ok = false
          for (let i = 0; i < inputs.length; i++) {
            if (inputs[i].value > 0) {
              ok = true
              let warehouse = row.warehouses.find(warehouse => warehouse.id === inputs[i].getAttribute('data-warehouse-id'))
              if (warehouse) {
                warehouse.qty = parseInt(warehouse.qty) + parseInt(inputs[i].value)
              } else {
                row.warehouses.push({
                  id: inputs[i].getAttribute('data-warehouse-id'),
                  name: inputs[i].getAttribute('data-warehouse-name'),
                  key: inputs[i].getAttribute('data-warehouse-key'),
                  qty: parseInt(inputs[i].value)
                })
              }
              row.qty = parseInt(row.qty) + parseInt(inputs[i].value)
              inputs[i].value = null
            }
          }
          if (!ok) {
            this.$notify({
              group: 'error',
              type: 'error',
              // title: 'Added',
              text: 'Specificati cantitatea pentru adaugare',
              'animation-type': 'css'
            })
          }
        } else {
          row.qty += this[collection][index]['qty']
          this[collection][index]['stoc'] = this[collection][index]['stoc'] - this[collection][index]['qty']
          this.increasePoints(row)
          this[collection][index]['qty'] = 1
          this.$notify({
            group: 'succes',
            type: 'success',
            // title: 'Added',
            text: collectionName + ' a fost adaugat in comanda',
            'animation-type': 'css'
          })
        }
      } else {
        if (collection === 'products') {
          let inputs = document.querySelectorAll("input[data-product='" + this.products[index].id + "']")
          let dataQty = []
          let ok = false
          let totalQty = 0
          for (let i = 0; i < inputs.length; i++) {
            if (inputs[i].value > 0) {
              ok = true
              dataQty.push({
                id: inputs[i].getAttribute('data-warehouse-id'),
                name: inputs[i].getAttribute('data-warehouse-name'),
                key: inputs[i].getAttribute('data-warehouse-key'),
                qty: parseInt(inputs[i].value)
              })
              totalQty = parseInt(totalQty) + parseInt(inputs[i].value)
              inputs[i].value = null
            }
          }
          if (ok) {
            let obj = {
              id: this.products[index].id,
              addition: 0,
              discount: 0,
              warehouses: dataQty,
              price_category: _.clone(this.globalPriceRange.key, true),
              price_category_name: _.clone(this.globalPriceRange.name, true),
              price: this.products[index][_.clone(this.globalPriceRange.name, true)],
              price_min: this.products[index].price_min,
              price_distribution: this.products[index].price_distribution,
              price_partner: this.products[index].price_partner,
              price_retail: this.products[index].price_retail,
              name: this.products[index].name,
              qty: totalQty
            }
            this.order_rows[collection].push(obj)
            this.$notify({
              group: 'succes',
              type: 'success',
              // title: 'Added',
              text: collectionName + ' a fost adaugat in comanda',
              'animation-type': 'css'
            })
            console.log(this.order_rows, 'order_rows')
          } else {
            if (!ok) {
              this.$notify({
                group: 'error',
                type: 'error',
                // title: 'Added',
                text: 'Specificati cantitatea pentru adaugare',
                'animation-type': 'css'
              })
            }
          }
        } else {
          let obj = {
            id: this[collection][index].id,
            qty: this[collection][index].qty,
            price: (collection !== 'post_services') ? this[collection][index].final_price : this[collection][index].price,
            name: (collection !== 'post_services') ? this[collection][index].name : `${this[collection][index].name} ${this[collection][index].value}`
          }
          this.order_rows[collection].push(obj)
          this.$notify({
            group: 'succes',
            type: 'success',
            // title: 'Added',
            text: collectionName + ' a fost adaugat in comanda',
            'animation-type': 'css'
          })
        }
      }
      this.$store.dispatch('orderRow', this.order_rows)
    },
    addItemOLd (index, collection) {
      console.log(index, 'index', collection, 'collection')
      let row = this.order_rows[collection].find(row => row.id === this[collection][index].id)
      console.log(row, 'ROW')
      let collectionName = ''
      switch (collection) {
        case 'products':
          collectionName = 'Produsul'
          break

        case 'services':
          collectionName = 'Serviciul'
          break

        case 'post_services':
          collectionName = 'Serviciul Post Vanzare'
          break
      }
      if (row) {
        console.log('iffff')
        // this.checkQuantity(index, collection)
        if (collection === 'products') {
          console.log('products')
          let inputs = document.querySelectorAll("input[data-product='" + this.products[index].id + "']")
          let ok = false
          for (let i = 0; i < inputs.length; i++) {
            if (inputs[i].value > 0) {
              ok = true
              let warehouse = row.warehouses.find(warehouse => warehouse.id === inputs[i].getAttribute('data-warehouse-id'))
              if (warehouse) {
                console.log('if warehouse')
                warehouse.qty = parseInt(inputs[i].value)
              } else {
                console.log('else warehouse')
                warehouse = {
                  id: inputs[i].getAttribute('data-warehouse-id'),
                  name: inputs[i].getAttribute('data-warehouse-name'),
                  key: inputs[i].getAttribute('data-warehouse-key'),
                  qty: parseInt(inputs[i].value)
                }
                row.warehouses.push(warehouse)
              }
              row.qty = parseInt(inputs[i].value)
              this.$store.dispatch('addProduct', {
                object: row,
                added: inputs[i].value,
                warehouse: warehouse
              })
              inputs[i].value = null
            }
          }
          if (!ok) {
            this.$notify({
              group: 'error',
              type: 'error',
              // title: 'Added',
              text: 'Specificati cantitatea pentru adaugare',
              'animation-type': 'css'
            })
          }
        } else {
          row.qty += this[collection][index]['qty']
          this[collection][index]['stoc'] = this[collection][index]['stoc'] - this[collection][index]['qty']
          this.increasePoints(row)
          this[collection][index]['qty'] = 1
          this.$notify({
            group: 'succes',
            type: 'success',
            // title: 'Added',
            text: collectionName + ' a fost adaugat in comanda',
            'animation-type': 'css'
          })
        }
      } else {
        console.log('else')
        if (collection === 'products') {
          console.log('else 1')
          let inputs = document.querySelectorAll("input[data-product='" + this.products[index].id + "']")
          let dataQty = []
          let ok = false
          let totalQty = 0
          for (let i = 0; i < inputs.length; i++) {
            if (inputs[i].value > 0) {
              ok = true
              dataQty.push({
                id: inputs[i].getAttribute('data-warehouse-id'),
                name: inputs[i].getAttribute('data-warehouse-name'),
                key: inputs[i].getAttribute('data-warehouse-key'),
                qty: parseInt(inputs[i].value)
              })
              totalQty = parseInt(inputs[i].value)
              inputs[i].value = null
            }
          }
          if (ok) {
            console.log('else ok')
            let obj = {
              id: this.products[index].id,
              addition: 0,
              discount: 0,
              warehouses: dataQty,
              price_category: _.clone(this.globalPriceRange.key, true),
              price_category_name: _.clone(this.globalPriceRange.name, true),
              price: this.products[index][_.clone(this.globalPriceRange.name, true)],
              price_min: this.products[index].price_min,
              price_distribution: this.products[index].price_distribution,
              price_partner: this.products[index].price_partner,
              price_retail: this.products[index].price_retail,
              name: this.products[index].name,
              qty: totalQty
            }
            this.$store.dispatch('addProduct', { object: obj, added: 0, warehouses: dataQty })
            //this.added.push(obj)
            //localStorage.setItem('adddedPRODUCTS', this.added)
            this.order_rows[collection].push(obj)
            this.$notify({
              group: 'succes',
              type: 'success',
              // title: 'Added',
              text: collectionName + ' a fost adaugat in comanda',
              'animation-type': 'css'
            })
          } else {
            if (!ok) {
              this.$notify({
                group: 'error',
                type: 'error',
                // title: 'Added',
                text: 'Specificati cantitatea pentru adaugare',
                'animation-type': 'css'
              })
            }
          }
        } else {
          console.log('else 2')
          let obj = {
            id: this[collection][index].id,
            qty: this[collection][index].qty,
            price: (collection !== 'post_services') ? this[collection][index].final_price : this[collection][index].price,
            name: (collection !== 'post_services') ? this[collection][index].name : `${this[collection][index].name} ${this[collection][index].value}`
          }
         // this.added.push(obj)
         // localStorage.setItem('adddedPRODUCTS', this.added)
          this.order_rows[collection].push(obj)
          this.$notify({
            group: 'succes',
            type: 'success',
            // title: 'Added',
            text: collectionName + ' a fost adaugat in comanda',
            'animation-type': 'css'
          })
        }
      }
    },
    getQty (stocks, warehouseId) {
      if (stocks.length > 0) {
        let stock = stocks.find(function (element) {
          return parseInt(element.warehouse_id) === parseInt(warehouseId)
        })
        if (stock) {
          return stock.qty
        }
      }
      return 0
    },
    getQtyReserved (stocks, warehouseId) {
      if (stocks.length > 0) {
        let stock = stocks.find(function (element) {
          return parseInt(element.warehouse_id) === parseInt(warehouseId)
        })
        if (stock) {
          return stock.reserved
        }
      }
      return 0
    },
  },
  computed: {
    start_page_products () {
      if (this.meta_products.last_page > 5 && this.meta_products.current_page > 2) {
        return parseInt(this.meta_products.current_page, 10) - 2
      } else {
        return 1
      }
    },
    // return last page from pagination html
    stop_page_products () {
      if (this.meta_products.last_page > 5 && this.meta_products.current_page + 2 < this.meta_products.last_page) {
        return parseInt(this.meta_products.current_page, 10) + 2
      } else {
        return this.meta_products.last_page
      }
    },
    // return only 5 pages for pagination
    products_pagination () {
      let pages = []
      for (let i = this.start_page_products; i <= this.stop_page_products; i++) {
        pages.push(i)
      }
      return pages
    },

    start_page_services () {
      if (this.meta_services.last_page > 5 && this.meta_services.current_page > 2) {
        return parseInt(this.meta_services.current_page, 10) - 2
      } else {
        return 1
      }
    },
    // return last page from pagination html
    stop_page_services () {
      if (this.meta_services.last_page > 5 && this.meta_services.current_page + 2 < this.meta_services.last_page) {
        return parseInt(this.meta_services.current_page, 10) + 2
      } else {
        return this.meta_services.last_page
      }
    },
    // return only 5 pages for pagination
    services_pagination () {
      let pages = []
      for (let i = this.start_page_services; i <= this.stop_page_services; i++) {
        pages.push(i)
      }
      return pages
    },

    start_page_post_service () {
      if (this.meta_post_services.last_page > 5 && this.meta_post_services.current_page > 2) {
        return parseInt(this.meta_post_services.current_page, 10) - 2
      } else {
        return 1
      }
    },
    // return last page from pagination html
    stop_page_post_service () {
      if (this.meta_post_services.last_page > 5 && this.meta_post_services.current_page + 2 < this.meta_post_services.last_page) {
        return parseInt(this.meta_post_services.current_page, 10) + 2
      } else {
        return this.meta_post_services.last_page
      }
    },
    // return only 5 pages for pagination
    post_service_pagination () {
      let pages = []
      for (let i = this.start_page_post_service; i <= this.stop_page_post_service; i++) {
        pages.push(i)
      }
      return pages
    }
  },
  async created () {
    await this.getProducts({ per_page: 40 })
    this.getWarehouses()
    this.userWarehouses = this.$store.getters.user.warehouses
    this.$store.dispatch('hideLoading')
  }
}
</script>
